import type { LoaderFunctionArgs, LinksFunction, MetaFunction } from '@remix-run/node';
import { json, redirect } from '@remix-run/node';
import { Outlet } from '@remix-run/react';
import stylesGlobal from '~/styles/global.css';
import awards2024CommonStyle from '~/styles/awards2024/common.css';

import Awards2024Banner from '~/components/awards2024/banner';
import Awards2024Nav from '~/components/awards2024/nav';
import Awards2024Footer from '~/components/awards2024/footer';
import { useContext } from 'react';
import { UserInfoContext, LoginDialogContext } from '~/signalsAndContext/LoginContext';
import Awards2024LoginDialog from '~/components/awards2024/login-dialog';
import getPlatform from '~/helpers/clientPath.server';
import { ExternalScriptsHandle } from 'remix-utils/external-scripts';

export const meta: MetaFunction = () => [
{
  viewport: 'width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no,viewport-fit=cover',
  'apple-mobile-web-app-capable': 'yes',
  'apple-mobile-web-app-status-bar-style': 'black',
  Copyright: 'Tencent',
  title: 'The GWB Game Awards 2024',
  description: 'A global indie game competition organised by the Tencent Institute of Games and the Hongshan District government of Wuhan. We aim to discover and celebrate the best new and upcoming games from around the world. ',
  keyword: ''
}];


export const handle: ExternalScriptsHandle = {
  scripts: [
  {
    src: 'https://www.google.com/recaptcha/api.js?render=explicit'
    // preload: true, // use it to render a <link rel="preload"> for this script
  }]

};

export const links: LinksFunction = () => [
{
  rel: 'stylesheet',
  href: stylesGlobal
},
{
  rel: 'stylesheet',
  href: awards2024CommonStyle
}];



export const loader = async ({ request }: LoaderFunctionArgs) => {
  // 双端跳转
  const platform = getPlatform(request.headers);
  console.info(platform);

  if (platform === 'mobile') {
    return redirect('/mobi/awards2024');
  }
  return json({});
};

const Layout = () => {
  const { showLoginDialog, setShowLoginDialogState } = useContext(LoginDialogContext);
  const { userInfo } = useContext(UserInfoContext);
  const handleCloseLoginDialog = () => {
    setShowLoginDialogState(false);
  };
  return <div className='main'>
    <Awards2024Banner userInfo={userInfo} />
    <Awards2024Nav />
    <Outlet />
    {
    showLoginDialog ? <Awards2024LoginDialog onCloseFn={handleCloseLoginDialog} /> : null
    }
    <Awards2024Footer />
  </div>;
};

export default Layout;